var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":_vm.onClick}},[_c('div',{staticClass:"panel__content",attrs:{"data-test-id":"panel-content"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }